import { configureStore } from '@reduxjs/toolkit';
import accountReducer from './accountSlice';
import profileReducer from './profileSlice';
import ssoUserReducer from './ssoUserSlice';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (e) {
    return undefined;
  }
};

const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (e) {
    // Ignore write errors;
  }
};

const peristedState = loadState();

export const store = configureStore({
  reducer: {
    profileReducer: profileReducer,
    accountReducer: accountReducer,
    ssoUserReducer: ssoUserReducer,
  },
  preloadedState: peristedState,
});

store.subscribe(() => {
  saveState(store.getState());
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
